import { all, call, select, put, takeLatest } from "redux-saga/effects";
import { addRoomRequested,
  ADD_ROOM,
  addRoomFailure,
  addRoomSuccess,
  fetchRoomRequested,
  FETCH_ROOM,
  fetchRoomFailure,
  fetchRoomSuccess,
  FETCH_ROOM_BY_ID,
  fetchRoomByIdFailure,
  fetchRoomByIdSuccess,
  fetchRoomByIdRequested,
  fetchRoomById }
  from "../actions/catelogue-types";
import httpClient from "./http-client";

export function* addRoomHandler({ payload }) {
  yield put(addRoomRequested());
  const userData = yield select((state) => state?.user?.user);
  const userId = userData.identifier;
  const request = {
    data: {
      payload: {
        description: payload.description,
        name: payload.name,
        coverImage: payload.media,
        taskId: payload.taskId,
        userId,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        isDeleted: false,
      },
    },
    method: "POST",
    url: "api/v1/catalogue",
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(addRoomFailure(error));
  } else {
    const roomId = data.details.id;

    yield put(fetchRoomById(roomId));
    yield put(addRoomSuccess(data));
  }
}

export function* fetchRoomHandler({ payload }) {
  yield put(fetchRoomRequested());
  const userData = yield select((state) => state?.user?.user);
  const userId = userData.identifier;
  const taskId = payload;
  const request = {
    method: "GET",
    params: {
      userId, taskId,
    },
    url: "/api/v1/catalogue",
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchRoomFailure(error));
  } else {
    yield put(fetchRoomSuccess(data.details));
  }
}

export function* fetchRoomByIdHandler({ payload }) {
  yield put(fetchRoomByIdRequested());

  const request = {
    method: "GET",
    url: `/api/v1/catalogue/${payload}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchRoomByIdFailure(error));
  } else {
    yield put(fetchRoomByIdSuccess(data.details));
  }
}

function* Locations() {
  yield all([
    takeLatest(ADD_ROOM, addRoomHandler),
    takeLatest(FETCH_ROOM, fetchRoomHandler),
    takeLatest(FETCH_ROOM_BY_ID, fetchRoomByIdHandler),
  ]);
}

export default Locations;
